export default {
  // ナビゲーションリンク
  home: 'ホーム',
  features: '機能',
  about: '私たちについて',
  contact: 'お問い合わせ',
  blog: 'ブログ',
  dashboard: 'ダッシュボード',
  settings: '設定',
  login: 'ログイン',
  signup: '登録',
  logout: 'ログアウト',
  supportUs: 'サポート',
  
  // ログアウト関連のテキスト
  loggingOut: 'ログアウト中...',
  redirectingToLogin: 'ログインページにリダイレクト中...'
};